module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('h3', [_vm._v("用户信息")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple",
    staticStyle: {
      "text-align": "center",
      "margin-top": "20px"
    }
  }, [_c('img', {
    staticStyle: {
      "border-radius": "50%"
    },
    attrs: {
      "width": "80px",
      "height": "80px",
      "src": _vm.userInfo.avatarUrl,
      "alt": ""
    }
  })])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple"
  }, [_c('p', [_vm._v("微信ID：" + _vm._s(_vm.userInfo.wxid))]), _vm._v(" "), _c('p', [_vm._v("昵称：" + _vm._s(_vm.userInfo.nickName))]), _vm._v(" "), _c('p', [_vm._v("是否绑定微信：" + _vm._s(_vm.userInfo.wxid ? '已绑定' : '未绑定'))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple"
  }, [_c('p', [_vm._v("手机号：" + _vm._s(_vm.userInfo.username))]), _vm._v(" "), _c('p', [_vm._v("注册时间：" + _vm._s(new Date(_vm.userInfo.created).getFullYear() + '-' + (new Date(_vm.userInfo.created).getMonth() + 1) + '-' + new Date(_vm.userInfo.created).getDate() + ' ' + new Date(_vm.userInfo.created).getHours() + ':' + new Date(_vm.userInfo.created).getMinutes() + ':' + new Date(_vm.userInfo.created).getSeconds()))]), _vm._v(" "), _c('p', [_vm._v("是否实名：" + _vm._s(_vm.userInfo.isIdentified ? '已实名' : '未实名'))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple"
  }, [_c('p', [_vm._v("性别：\n                    "), (_vm.userInfo.gender === '1') ? _c('span', [_vm._v("男")]) : _vm._e(), _vm._v(" "), (_vm.userInfo.gender === '2') ? _c('span', [_vm._v("女")]) : _vm._e(), _vm._v(" "), (_vm.userInfo.gender === '0' || _vm.userInfo.gender === null) ? _c('span', [_vm._v("暂无")]) : _vm._e()]), _vm._v(" "), (_vm.Role === '1') ? _c('p', [_vm._v("密码：\n                    "), _c('el-button', {
    on: {
      "click": _vm.changePsd
    }
  }, [_vm._v("修改")])], 1) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("客户端来源：\n                    "), _c('span', [_vm._v(_vm._s(_vm.clientTypeMap[_vm.userInfo.clientType]))])])])])], 1), _vm._v(" "), _c('el-form', {
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true,
      "model": _vm.userInfo
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "label": "真实姓名"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.otherInfo.zmName || _vm.otherInfo.realName || '无'))])]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "label": "身份证号"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.otherInfo.zmIdCard || _vm.otherInfo.idCard || '无'))])]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "label": "工作单位／学校"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.otherInfo.institution || '无'))])]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "label": "现居住地址"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.otherInfo.address || '无'))])])], 1), _vm._v(" "), _c('el-form', {
    staticClass: "demo-ruleForm",
    attrs: {
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "已通过审核实名信息"
    }
  }, [_c('div', [_vm._l((_vm.otherInfo.pictures), function(item, index) {
    return (index != 3 && _vm.userInfo.isIdentified) ? _c('img', {
      key: index,
      staticStyle: {
        "margin-right": "15px",
        "width": "200px"
      },
      attrs: {
        "src": item,
        "alt": ""
      }
    }) : _vm._e()
  }), _vm._v(" "), (!_vm.userInfo.isIdentified) ? _c('span', [_vm._v("暂无")]) : _vm._e()], 2)])], 1), _vm._v(" "), _c('el-form', {
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true,
      "model": _vm.userInfo
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "label": "芝麻信用分值"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.userInfo.zmScore || 0))])]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "label": "已获得免押金额度（单位：元）"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.userInfo.totalLine || 0))])]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "label": "当前剩余免押金额度（单位：元）"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.userInfo.totalRemain || 0))])]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "label": "芝麻信用获取的免押金额度（单位：元）"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.userInfo.zmLine || 0))])]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "label": "实名认证获取的免押金额度（单位：元）"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.userInfo.identifiedLine || 0))])])], 1), _vm._v(" "), _c('el-form', {
    staticClass: "demo-ruleForm",
    attrs: {
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "学生证照片"
    }
  }, [(_vm.otherInfo.pictures && _vm.otherInfo.pictures[3].length) ? _c('img', {
    staticStyle: {
      "margin-right": "15px",
      "width": "300px"
    },
    attrs: {
      "src": _vm.otherInfo.pictures[3],
      "alt": ""
    }
  }) : _c('span', [_vm._v("暂无")])])], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.handleOrder
    }
  }, [_vm._v("查看用户订单")]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "修改密码",
      "visible": _vm.dialogFormVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.psdForm,
      "label-width": "150px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "密码"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.psdForm.psd),
      callback: function($$v) {
        _vm.$set(_vm.psdForm, "psd", $$v)
      },
      expression: "psdForm.psd"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitNew
    }
  }, [_vm._v("确定修改")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "用户订单",
      "visible": _vm.dialogOrderVisible,
      "size": "large"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogOrderVisible = $event
      }
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.orderData
    }
  }, [_c('el-table-column', {
    attrs: {
      "property": "orderNo",
      "label": "订单编号",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "label": "商品名",
      "width": "200"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return (_vm.row && _vm.row.dispalyExtra) ? _c('div', _vm._l((_vm.row.dispalyExtra.mainItems), function(item) {
            return _c('p', [_vm._v(_vm._s(item.name))])
          }), 0) : _vm._e()
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "receiverName",
      "label": "收货人"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "receiverTel",
      "label": "收货人电话"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "address",
      "label": "收货地址"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "counts",
      "label": "商品数量"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "label": "订单状态"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [(_vm.row.status === 0) ? _c('span', [_vm._v("待付款")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 1) ? _c('span', [_vm._v("待发货")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 2) ? _c('span', [_vm._v("交易关闭")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 3) ? _c('span', [_vm._v("待收货")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 4) ? _c('span', [_vm._v("待返还")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 5) ? _c('span', [_vm._v("待返还")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 6) ? _c('span', [_vm._v("待返还确认")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 7) ? _c('span', [_vm._v("已完成")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 8) ? _c('span', [_vm._v("退款中")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 9) ? _c('span', [_vm._v("已退款")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 100) ? _c('span', [_vm._v("已删除")]) : _vm._e()])
        
      },
      staticRenderFns: []
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c85cc644"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/user/UserView.vue
// module id = 752
// module chunks = 1